// defaultMaxPageSize can be used for paginated endpoints where you don't want server pagination
const defaultMaxPageSize = 1_000_000;
const gemeenteRolId = 1;
const milieudienstRolId = 2;
export const constants = { defaultMaxPageSize, gemeenteRolId, milieudienstRolId };

